import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Button, ButtonProps, Translucent } from '@amzn/dvui/dist/Button'
import { ActionForm } from '../../utils/actionForm'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'
import { clearWatchlistFailure, toggleWatchlist } from '../../actions/watchlist'
import { WatchlistToggleInput } from 'DVWebNodeUtils'
import { IDetailPageState } from '../../reducers'
import { watchlistComponentSelector } from '../../selectors/component/watchlistComponentSelectors'
import { SpinnerWithDelay } from '../spinners/spinnerWithDelay'
import { ModalTrigger, ModalRenderPropArgs } from '@shared/utils/modalTrigger/ModalTrigger'
import * as st from './watchlist.module.scss'
import { isTreatment } from '../../utils/utils'
import { acknowledgeEvent } from '@shared/utils/events'
import * as cn from 'classnames'
import * as utilityClasses from '../utilityClasses.module.scss'
import { AtfTreatmentProps } from '../../reducers/features'
import { simpleSelectors } from '../../selectors/basicState'
import { IconType } from '@amzn/dvui/dist/Icon'

// TODO: AVWebDetailPage-1781

const TAG_REMOVE = 'Remove'

export interface IWatchlistProps {
  partialURL: string
  query: WatchlistToggleInput
  tag: WpsRuntime.atv.wps.WatchlistActionTag
  text: WpsRuntime.atv.wps.DVString
  ajaxEnabled: boolean
  isSeason: boolean
  failed: boolean
}

type StateProps = {
  watchlist?: IWatchlistProps
  pageTitleId: string
} & AtfTreatmentProps

type LocalState = {
  disabled: boolean
  isLoading: boolean
}

type ExtraProps = {
  isHover: boolean
}

type ConnectedWatchlistProps = StateProps & ExtraProps
export class ConnectedWatchlist extends React.Component<
  ConnectedWatchlistProps,
  LocalState
> {
  state = {
    disabled: false,
    isLoading: false,
  }

  clickHandler = (e: React.MouseEvent<HTMLElement>) => {
    acknowledgeEvent(e)
    this.setState({
      disabled: true,
      isLoading: true,
    })
    toggleWatchlist(this.props.watchlist!.query, this.props.pageTitleId)
    e.preventDefault()
  }

  componentDidUpdate(prevProps: ConnectedWatchlistProps) {
    if (prevProps !== this.props) {
      this.setState({
        disabled: false,
        isLoading: false,
      })
    }
  }

  render() {
    const { watchlist, isHover, atfTreatment } = this.props

    if (!watchlist) {
      return null
    }

    // ajaxEnabled is false for unrecognized users: https://code.amazon.com/packages/ATVWebPresentationScala/blobs/invoices/--/src/atv/web/presentation/WatchlistAction.scala#L128
    const { partialURL, query, tag, ajaxEnabled, isSeason, failed } = watchlist

    const isOnWatchlist = tag === TAG_REMOVE

    const addStringsId = isSeason
      ? StringId.DV_DP_WL_addTv
      : StringId.DV_DP_WL_addMovie
    const addedStringsId = isSeason
      ? StringId.DV_DP_WL_removeTv
      : StringId.DV_DP_WL_removeMovie
    const toggleStringId = (isOnWatchlist ? addedStringsId : addStringsId)
    const toggleIcon = (isOnWatchlist ? IconType.WATCHLIST_ON : IconType.ADD)

    const buttonStyling = cn(
      st.button,
      { [st.hoverButton]: isHover },
    )

    const atfTreatmentProps: ButtonProps = {
      ...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { useIcon: toggleIcon }),
      ...(isTreatment(atfTreatment,'T1', 'T3') && {
        shape: 'pill',
        use: Translucent
      })
    }

    // TODO: Add refTag : AVWebDetailPage-1782
    // Legacy: add pageType/subPageType to hiddenInputs
    // utility to call gp/video/ajax/analytics.html/ref=<ref_tag>

    return (
      <span className={cn(isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? st.watchlistWrapper : utilityClasses.fullWidthPhablet, 'dv-dp-node-watchlist')}>
        <ActionForm
          action={partialURL}
          method="POST"
          hiddenInputs={query as { [key: string]: string }}
        >
          <Button
            disabled={this.state.disabled}
            className={cn(buttonStyling, {[st.watchlistButton]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}
            onClick={ajaxEnabled ? this.clickHandler : undefined}
            forceDoubleHeight={!isHover && !isTreatment(atfTreatment, 'T1', 'T2', 'T3')}
            data-ux-click
            type="submit"
            data-added={isOnWatchlist}
            {...atfTreatmentProps}
          >
            <SpinnerWithDelay isLoading={this.state.isLoading}>
              <TextLocalizer stringID={isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? StringId.DV_DP_WL_watchlist : toggleStringId} />
            </SpinnerWithDelay>
          </Button>
        </ActionForm>

        <ModalTrigger
          modalId='dvui-close-overlay-watchlist-failed'
          isOpen={failed}
          modalHeader={<TextLocalizer stringID={toggleStringId} />}
          modalContent={<TextLocalizer stringID={StringId.AVOD_WL_error_msg} />}
          modalFooter={
            ({ closeModal }: ModalRenderPropArgs) => {
              return (
                <Button className={utilityClasses.alwaysInline} onClick={() => closeModal()} >
                  <TextLocalizer stringID={StringId.AVOD_DP_E_error_ok} />
                </Button>
              )
            }
          }
          onClose={() => clearWatchlistFailure(this.props.pageTitleId)} />
      </span>
    )
  }
}

const mapStateToProps = (state: IDetailPageState): StateProps => {
  return {
    watchlist: watchlistComponentSelector(state),
    pageTitleId: state.pageTitleId,
    atfTreatment: simpleSelectors.atfTreatment(state)
  }
}

export const Watchlist = connect(mapStateToProps)(ConnectedWatchlist)
